"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utils = require("../../utils/utils");

var _Box = _interopRequireDefault(require("../../layout/Box"));

var _Stack = _interopRequireDefault(require("../../layout/Stack"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Nav = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "SideBarNavItemContainer__Nav",
  componentId: "sc-1wx5n30-0"
})(["display:flex;flex-flow:row nowrap;flex-grow:1;"]);
var SideBarNavItemUl = (0, _styledComponents["default"])(_Stack["default"]).withConfig({
  displayName: "SideBarNavItemContainer__SideBarNavItemUl",
  componentId: "sc-1wx5n30-1"
})(["list-style:none;width:100%;"]);
/**
 *
 * ### `SideBarNavItem` container component

Creates a `<nav>` container for the sidebar's links, which are rendered as a list within a `<ul>` element. Expects to take **SideBarNavItem**s as children. It always stretches to fill the 100% of its parent width. When the collapsed prop is passed,
it is only being applied to the children, and does not affect the container itself.

Please note - this component has no playground as it is only ever used as a child of Sidebar
 */

var SideBarNavItemContainer = function SideBarNavItemContainer(_ref) {
  var children = _ref.children,
      _ref$collapsed = _ref.collapsed,
      collapsed = _ref$collapsed === void 0 ? false : _ref$collapsed;
  return /*#__PURE__*/_react["default"].createElement(Nav, {
    element: "nav",
    padding: "base",
    collapsed: collapsed
  }, /*#__PURE__*/_react["default"].createElement(SideBarNavItemUl, {
    element: "ul",
    collapsed: collapsed,
    gap: "base"
  }, (0, _utils.clonePropsToChildren)(children, {
    collapsed: collapsed
  })));
};

var _default = SideBarNavItemContainer;
exports["default"] = _default;